import Route from 'cio/routes/base';
import CampaignOverviewMetricsIndexController from './controller';
import Transition from '@ember/routing/-private/transition';
import CampaignModel from 'cio/models/campaign';
import { isEmpty } from '@ember/utils';
import { inject as service } from '@ember/service';
import RouterService from '@ember/routing/router-service';

export default class CampaignOveviewMetricsIndexRoute extends Route {
  @service router!: RouterService;

  templateName = 'base/overview/metrics';

  model() {
    return this.modelFor('campaigns.campaign');
  }

  setupController(controller: CampaignOverviewMetricsIndexController, model: CampaignModel, transition: Transition) {
    super.setupController(controller, model, transition);

    controller.limitEndTime();
    controller.deserializeQueryParams();
    controller.setAllAvailableChannels();

    // note: utilizing anchor/hash to maintain legacy functionality that provides
    // a URL directly to either the delivery or journey metrics panel
    let { hash } = window.location;
    if (!isEmpty(hash)) {
      // default tab set to delivery so no need to check for it
      if (hash.includes('journey')) {
        controller.graphTab = 'journey';
      }
    }
  }

  resetController(controller: CampaignOverviewMetricsIndexController, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      controller.resetQueryParams();
    }
  }

  redirect(model: CampaignModel) {
    if (model.isDataCampaign) {
      this.router.transitionTo('campaigns.campaign.overview');
    }
  }
}
